var map = {
	"./GenJyuuGothic-P-Bold.woff": 900,
	"./GenJyuuGothic-P-Light.woff": 849,
	"./GenJyuuGothic-P-Regular.woff": 889,
	"fonts/GenJyuuGothic-P-Bold.woff": 900,
	"fonts/GenJyuuGothic-P-Light.woff": 849,
	"fonts/GenJyuuGothic-P-Regular.woff": 889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 398;